module.exports = __webpack_public_path__ + "static/media/intro.e9057fa4.mp3";